import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import AreaAPI from '../../api/AreaAPI';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import Display from '../../util/Display';
import ApiUiController from '../../controller/ApiUiController';

class AreaList extends React.Component {

  constructor(props) {
    super(props);
    this.areas = [];
    this.state = { ...this.state, area: {}, popup:false, inApiCall: true };

    const model = reactLocalStorage.getObject(Const.Model).area;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount(){
    if(this.List) AreaAPI.list(this.onReceived)}
  onReceived = res => {this.areas = res; this.setState({ inApiCall: false });}

  show=i=> {
    this.setState({ ...this.state,
      area: {id: i===-1?0:this.areas[i].id, name: i===-1?'':this.areas[i].name},
      popup: true });
  } 
  hide = () => { this.setState({...this.state, popup: false}); }
  save = () => {
    if(this.state.area.name.trim().length === 0) {
      return;
    }
    this.setState({...this.state, popup: false, inApiCall: true});
    AreaAPI.save(this.state.area, this.success);
  }
  success = () => {
    Util.showNotification('Successful', 'Area successfully saved', 'success')
    this.props.onModuleChanged();
    AreaAPI.list(this.onReceived);
  }
  nameChange=value=>this.setState({...this.state,area:{...this.state.area, name: value}})
  
  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.areas[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        AreaAPI.delete(this.areas[index].id, this.onDelete);
    });
  }

  onDelete = () => {
    Util.showNotification('Successful', 'Area Deleted successfully', 'success');
    AreaAPI.list(this.onReceived);
  }

  render() {
    if(!this.List) return null;
    const areasUI = this.areas.map((area, _i) => (
      <tr key={`product_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{area.name}</td>
        <td>{Display.ModelLabelValue('user', area.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(area.created_date)}</td>
        <td>{Display.ModelLabelValue('user', area.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(area.updated_date)}</td>
        <td>
          { this.Update && 
            <div className="buttons success" onClick={() => this.show(_i)}><FaPencilAlt/> Update</div>
          }
          { area.status !== Const.AlwaysActive && this.Delete &&
            <div onClick={() => this.confirmDelete(_i)} className="buttons delete"><FaTrash/> Delete</div>
          }
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          show={this.state.popup} onHide={this.hide} 
          size="md" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Area</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="row-cols-2 colmr">
                <Col xs={12}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Area Name"
                    className="mr-sm-2"
                    value={this.state.area.name}
                    onChange={event => this.nameChange(event.target.value)} />
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
        </Modal>

        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 pb-3"><h3>Area List</h3></div>
                { this.Add &&
                  <div className="col-md-2 text-right pb-3">
                    <div className="buttons success"
                      onClick={() => this.show(-1)}>+ Add Area</div>
                  </div>
                }
                <div className="col-md-12">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th>Created By</th>
                        <th>Created Date</th>
                        <th>Updated By</th>
                        <th>Updated Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ApiUiController inApiCall={this.props.inApiCall}>
                        { areasUI }
                      </ApiUiController>
                    </tbody>
                  </Table>
                </div>
            </div>
          </div>
        
        </div>
      </>
    );
  }
}
export default AreaList;